import { useTypedSelector } from "../../app";
import { PermissionEnum } from "../../models";

export const usePermission = () => {
  const permissions = useTypedSelector(
    (state) => state.application.user.permissions
  );

  const hasPermission = (permission: PermissionEnum) => {
    return permissions?.includes(permission);
  };

  return {
    hasPermission,
  };
};
